import { Modal } from 'framework/ui/ui-builder';
import { ModalForm, FormFieldsData, AfterSubmitProps } from 'framework/form';
import { BackupInitialData } from '../types';
import useUpcomingChangesService from '../upcomingChangesService';
import BackupReplacementForm from './BackupReplacementForm';
import { UpcomingChangeType } from '../constants';

const BackupModal = ({
  modalOpen,
  setModalOpen,
  handleSubmit,
  onDelete = () => Promise.resolve(),
  afterSubmit,
  initialData,
  teamStructure,
  type,
}: {
  modalOpen: boolean;
  setModalOpen: (status: boolean) => void;

  handleSubmit: (values: FormFieldsData) => Promise<void>;
  onDelete?: (data: FormFieldsData) => Promise<void>;
  afterSubmit?: AfterSubmitProps<(response: any) => any, string | ((response: any) => any)>;

  initialData?: BackupInitialData;
  teamStructure: any;
  type: UpcomingChangeType;
}) => {
  const { getBackupValidationSchema, getReplacementValidationSchema } = useUpcomingChangesService();

  return (
    <Modal
      modalSize={'sm'}
      isOpen={modalOpen}
      onToggle={() => setModalOpen(false)}
      title={`Please, enter ${type === UpcomingChangeType.BACKUP ? 'backup' : 'replacement'} details`}
    >
      <ModalForm
        initialData={initialData}
        closeModal={() => setModalOpen(false)}
        modalOpen={modalOpen}
        submitFormFunc={handleSubmit}
        afterSubmit={afterSubmit}
        getValidationSchemaFunc={
          type === UpcomingChangeType.BACKUP ? getBackupValidationSchema : getReplacementValidationSchema
        }
        isHideDefaultButtons
      >
        <BackupReplacementForm
          teamStructure={teamStructure}
          backupReplacementLabel={type === UpcomingChangeType.BACKUP ? 'Backup' : 'Replacement'}
          isUpdateMode={!!initialData?.upcomingChangeId}
          onClose={() => setModalOpen(false)}
          onDelete={initialData?.upcomingChangeId ? onDelete : undefined}
        />
      </ModalForm>
    </Modal>
  );
};

export default BackupModal;
